import React, { useState } from 'react';
import { Row, Col } from 'antd';
import PropTypes from 'prop-types';
import Avatar from './Avatar';
import ModalDeleteConfirmation from './ModalDeleteConfirmation';
import Button from '../../main/components/Button';

const EstablishmentList = ({
  establishments = [],
  onDelete,
  getAvatarUrl = () => {},
}) => {
  return (
    <div className="user-list">
      {establishments.map((establishment) => (
        <InnerSection
          key={establishment.id}
          establishment={establishment}
          onDelete={onDelete}
          getAvatarUrl={getAvatarUrl}
        />
      ))}
    </div>
  );
};

const InnerSection = ({ establishment, onDelete, getAvatarUrl }) => {
  const [deleteVisible, setDeleteVisible] = useState(false);

  return (
    <Row
      gutter={[10, 24]}
      justify="space-between"
      align="middle"
      className="user-list-row"
    >
      <Col span={2}>
        <Avatar
          alt={establishment.name}
          fullName={establishment.name}
          url={getAvatarUrl(establishment)}
        />
      </Col>
      <Col span={16}>{establishment.name}</Col>
      <Col span={4}>
        <Button
          variant="destructiveOutline"
          type="button"
          onClick={() => {
            setDeleteVisible(true);
          }}
        >
          Delete
        </Button>

        <ModalDeleteConfirmation
          visible={deleteVisible}
          confirmationTitle="Delete Establishment"
          onClose={() => {
            setDeleteVisible(false);
          }}
          onDelete={() => {
            onDelete(establishment.id);
          }}
        />
      </Col>
    </Row>
  );
};

EstablishmentList.propTypes = {
  establishments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ),
  // eslint-disable-next-line react/no-unused-prop-types
  avatarVisible: PropTypes.bool,
  getAvatarUrl: PropTypes.func, // (establishment, index) => return avatar imageUrl
  onDelete: PropTypes.func,
};
export default EstablishmentList;
